// extracted by mini-css-extract-plugin
module.exports = {"title":"info-source-disclaimer_title__EtVVv"};